<template>
  <vue-treeselect v-model="val"
                  class="hidden"
                  multiple
                  clearable
                  always-open
                  sort-value-by="INDEX"
                  value-consists-of="LEAF_PRIORITY"
                  :noOptionsText="$t('message.generics.message.noOptionsText')"
                  :maxHeight="dataMaxHeight"
                  :default-expand-level="1"
                  :options="mapped"></vue-treeselect>
</template>

<script>
import VueTreeselect from "@riophae/vue-treeselect";
import _ from "lodash";
import vModel from "@mixins/v-model";

export default {
  components: {
    VueTreeselect,
  },

  props: {
    dataMaxHeight: {
      type: Number,
      default: 305,
    },
  },

  computed: {
    rawDevices() {
      return this.$store.state.devices.list;
    },

    mapped() {
      const devices = this.rawDevices;

      let establishments = _.uniqBy(devices, (device) => {
        return device.estabelecimentoId;
      });

      establishments = _.map(establishments, (place) => {
        return {
          id: `est-${place.estabelecimentoId}`,
          label: place.estabelecimentoNome,
          children: [],
        };
      });

      _.forEach(devices, (device) => {
        const where = _.find(establishments, (place) => {
          return `est-${device.estabelecimentoId}` === place.id;
        });

        device = {
          id: device.id,
          label: device.nome,
          selected: false,
        };

        where.children.push(device);
      });
      return establishments;
    },
  },

  mixins: [vModel],
};
</script>

<style scoped>
</style>
